import { render, staticRenderFns } from "./RecordTable.vue?vue&type=template&id=26e94c00&"
import script from "./RecordTable.vue?vue&type=script&lang=ts&"
export * from "./RecordTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports